module.exports = __webpack_public_path__ + "static/Mental Health-bg@3x-d3c3c680b983866b9d1175df920f9b5d.png";